import { presenceLabel, type Presence } from '../lib/presence';

/** Pastille verte posée sur un avatar ; « en ligne » est dit à part aux lecteurs d'écran. */
export function PresenceDot({ presence }: { presence?: Presence | null }) {
  if (!presence?.online) return null;
  return <span className="messaging-presence-dot" aria-hidden="true" />;
}

/** Mention « en ligne » pour les lecteurs d'écran, à côté d'un nom. */
export function PresenceText({ presence }: { presence?: Presence | null }) {
  if (!presence?.online) return null;
  return <span className="messaging-sr-only"> (en ligne)</span>;
}

/** Libellé sous le titre d'une conversation : « En ligne » en vert, sinon « Vu … ». */
export function PresenceLabel({ presence }: { presence?: Presence | null }) {
  const label = presenceLabel(presence);
  if (!label) return null;
  return (
    <span
      className={
        presence?.online
          ? 'messaging-presence-label messaging-presence-label--online'
          : 'messaging-presence-label'
      }
    >
      {label}
    </span>
  );
}
